export const runStatusBadgeMessages = {
  ON_SCHEDULE: 'On Schedule',
  OVERDUE: 'Overdue',
  PENDING: 'Pending',
};

export const heartbeatStatusBadgeMessages = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const blankLabel = '(Blanks)';

const runStatusMessages = [
  runStatusBadgeMessages.OVERDUE,
  runStatusBadgeMessages.PENDING,
  runStatusBadgeMessages.ON_SCHEDULE,
];

export const getRunStatusMessage = index => runStatusMessages[index];

const heartbeatStatusMessages = [
  heartbeatStatusBadgeMessages.INACTIVE,
  heartbeatStatusBadgeMessages.ACTIVE,
];

export const getHeartbeatStatusMessage = index => heartbeatStatusMessages[index];
